import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Switch, Select, Radio, Tooltip } from 'antd'
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
import './openclass.less'
const { Option } = Select;
let dragingIndex = -1;
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class Openclass extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectValue: undefined,
			total: 0,
			subjectId: '',
			modelTitle: '新增学科',
			visible: false,
			releaseVisible: false,
			url: '',
			qiuniuUrl: '',
			qiuniuUrl2: '',
			subjectName:'',
			subjectIcon: null,
			clickUrl: '',
			groupUrl: '',
			zsCourseId: undefined,
			advPic: null,
			changeSwitch: false,
			name: '',
			subject: '',
			type: 1,
			courseType: '',
			optionList: [],
			vocateData: [],
			energizeData: [],
			classifyList: [],
			searchData: {
				status: '',
				pageNum: 1,
				pageSize: 10
			},
			vocateSearch: {
				pageNum: 1,
				pageSize: 10,
			},
			vocatotal: 0,
			energizeSearch: {
				pageNum: 1,
				pageSize: 10,
			},
			energtotal: 0,
			columns: [
				{
					title: '学科名称',
					dataIndex: 'name',
					key: 'name',
					width: '140px'
				},
				{
					title: '配套资料',
					dataIndex: 'materialName',
					key: 'materialName',
					ellipsis : true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
					)
				},
				{
					title: '创建人',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center',
					ellipsis: true,
					render: (text, record) => (
						<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
					)
				},
				{
					title: '发布状态',
					dataIndex: 'status',
					key: 'status',
					align: 'center',
					width: '90px',
					render: (record,text) => {
						return (
							<div>
								<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
									 let id = text.id
									 let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].status = checked===true? 1: 0
											// console.log(text.status)
											this.setState({
												subjecListData: arr
											})
										}
									}
									return (
										Modal.confirm({
											title: `${checked === true ? '发布学科' : '取消发布'}`,
											okText: "确定",
											cancelText: "取消",
											content: (
												<div>
													<p>{checked === true ? '发布后此学科将同步至用户端，请谨慎操作！确定要发布吗？' : '取消发布后用户端将无法学习此学科，请谨慎操作！确定要取消发布吗？'}</p>
												</div>
											),
											onOk: () => {
												this.isRelease(id,checked,'ok')
											},
											onCancel: () => {
												this.isRelease(id,checked,'cancel')
											}
										})
									)
								}} />

							</div>
						)
					}
				},
				{
					title: '同步至题库',
					dataIndex: 'question',
					key: 'question',
					align: 'center',
					width: '120px',
					render:(record, obj) => {
						// console.log(record,obj)
						return (
							<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
								// console.log(checked)
								  let id = obj.id
									let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].question = checked===true? 1: 0
											this.setState({
												subjecListData: arr
											})
										}
									}
									this.topicChange(checked, obj, 1)
							}} />
						)
					}
				},
				{
					title: '同步至资料包',
					dataIndex: 'datum',
					key: 'datum',
					align: 'center',
					width: '120px',
					render:(record, obj) => {
						// console.log(record,obj)
						return (
							<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
								  let id = obj.id
									let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].datum = checked===true? 1: 0
											this.setState({
												subjecListData: arr
											})
										}
									}
									this.topicChange(checked, obj, 2)
							}} />
						)
					}
				},
				{
					title: '同步至资料广场',
					dataIndex: 'materialsChecked',
					key: 'materialsChecked',
					align: 'center',
					width: '140px',
					render:(record, obj) => {
						return (
							<Switch defaultChecked={record?true:false} key={record?true:false} onChange={(checked) => {
								  let id = obj.id
									let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].materialsChecked = checked?true:false
											this.setState({
												subjecListData: arr
											})
										}
									}
									this.topicChange(checked, obj, 4)
							}} />
						)
					}
				},
				{
					title: '同步至课程管理',
					dataIndex: 'courseChecked',
					key: 'courseChecked',
					align: 'center',
					width: '130px',
					render:(record, obj) => {
						// console.log(record,obj)
						return (
							<Switch defaultChecked={record} key={record} onChange={(checked) => {
								  let id = obj.id
									let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].courseChecked = checked
											this.setState({
												subjecListData: arr
											})
										}
									}
									this.topicChange(checked, obj, 5)
							}} />
						)
					}
				},
				{
					title: '同步至资源管理',
					dataIndex: 'course',
					key: 'course',
					align: 'center',
					width: '130px',
					render:(record, obj) => {
						// console.log(record,obj)
						return (
							<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
								// console.log(checked)
								  let id = obj.id
									let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].course = checked===true? 1: 0
											this.setState({
												subjecListData: arr
											})
										}
									}
									this.topicChange(checked, obj, 3)
							}} />
						)
					}
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					width: '166px',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.props.history.push('/createSubject',{courseTitle: '编辑', id: record.id})
						}}>编辑</span>
						<span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}} onClick={()=> {
							sessionStorage.setItem('subjectId',record.id)
							this.props.history.push('/Stage')
						}}>阶段</span>
						<span style={{marginRight:'15px',color: '#277FFF', cursor: 'pointer'}} onClick={()=> {
							sessionStorage.setItem('subjectId',record.id)
							this.props.history.push('/ExcellentCourse')
						}}>精品课</span>
						{record.status === 0 ? <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除学科',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>学科删除后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delSubject('subjects', record.id)
								},
							});
						}}>删除</span>:''}
					</div>
				},
			],
			vocateColumn: [
				{
					title: '课程ID',
					dataIndex: 'id',
					key: 'id',
					width: '80px'
				},
					{
						title: '课程名称',
						dataIndex: 'name',
						key: 'name',
						ellipsis: true,
						render: (text, record) => (
							<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
						)
				},
				{
					title: '学科',
					dataIndex: 'subjectName',
					key: 'subjectName',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '创建人',
					dataIndex: 'createName',
					key: 'createName',
					align: 'center'
				},
				{
					title: '发布状态',
					dataIndex: 'publish',
					key: 'publish',
					align: 'center',
					render:(record, obj) => {
						// console.log(record,obj)
						return (
							<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
								// console.log(checked)
								  let id = obj.id
									let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].course = checked===true? 1: 0
											this.setState({
												subjecListData: arr
											})
										}
									}
									this.vocatChange(checked, obj)
							}} />
						)
					}
				},{
					title: '操作',
					key: 'operate',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.props.history.push('/createVocation',{courseTitle: '编辑', id: record.id})
						}}>编辑</span>
						{record.publish === 0 ? <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除就业课',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>学科就业课后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									// this.delVocation(record.id)
									this.delSubject('vocat', record.id)
								},
							});
						}}>删除</span>:''}
					</div>
				}
				// }
			],
			energizeColumn: [
				{
					title: '课程ID',
					dataIndex: 'id',
					key: 'id',
					width: '80px'
				},
					{
						title: '课程名称',
						dataIndex: 'name',
						key: 'name',
						ellipsis: true,
						render: (text, record) => (
							<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
						)
				},
				{
					title: '课程类型',
					dataIndex: 'courseTypeName',
					key: 'courseTypeName',
					align: 'center'
				},
				{
					title: '观看人数',
					dataIndex: 'viewNum',
					key: 'viewNum',
					align: 'center'
				},
				{
					title: '观看量',
					dataIndex: 'totalViewNum',
					key: 'totalViewNum',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '创建人',
					dataIndex: 'createName',
					key: 'createName',
					align: 'center'
				},
				{
					title: '发布状态',
					dataIndex: 'publish',
					key: 'publish',
					align: 'center',
					render:(record, obj) => {
						// console.log(record,obj)
						return (
							<Switch defaultChecked={record === 1 ? true : false} key={record === 1 ? true : false} onChange={(checked) => {
								// console.log(checked)
								  let id = obj.id
									let arr = this.state.subjecListData
									for(let i = 0; i<arr.length; i++){
										if(id === arr[i].id){
											arr[i].course = checked===true? 1: 0
											this.setState({
												subjecListData: arr
											})
										}
									}
									this.energizeChange(checked, obj)
							}} />
						)
					}
				},{
					title: '操作',
					key: 'operate',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.props.history.push('/createEnergize',{courseTitle: '编辑', id: record.id})
						}}>编辑</span>
						{record.publish === 0 ? <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除就业课',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>学科就业课后将不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									// this.delVocation(record.id)
									this.delSubject('energiz', record.id)
								},
							});
						}}>删除</span>:''}
					</div>
				}
			],
			subjecListData: [],
			notChanged: []
		}
	}
	// 就业课状态
	vocatChange = async(checked, obj) => {
		Modal.confirm({
			title: `${checked ? '发布' : '取消发布'}`,
			content: `${checked ? '确定要发布么？' : '确定要取消发布么？'}`,
			okText: '确定',
			cancelText: '取消',
			onOk: () => {
				let url = checked?'employmentcourse/publish':'employmentcourse/cancelPublish'
				
				axios.get(url+'/'+obj.id).then(res => {
					console.log(res)
					if(res.data.code === '200') {
						message.success(`${checked === true ? '发布成功' : `取消成功`}`)
						this.vocatonList()
						Modal.destroyAll();
					}else{
						this.vocatonList()
					}
				})
			},
			onCancel: () => {
				this.vocatonList()
			}
		})
	}
	energizeChange = async(checked, obj) => {
		Modal.confirm({
			title: `${checked ? '发布' : '取消发布'}`,
			content: `${checked ? '确定要发布么？' : '确定要取消发布么？'}`,
			okText: '确定',
			cancelText: '取消',
			onOk: () => {
				let url = checked?'empowerCourseController/publish':'empowerCourseController/cancelPublish'
				
				axios.get(url+'/'+obj.id).then(res => {
					console.log(res)
					if(res.data.code === '200') {
						message.success(`${checked === true ? '发布成功' : `取消成功`}`)
						this.energizeList()
						Modal.destroyAll();
					}else{
						this.energizeList()
					}
				})
			},
			onCancel: () => {
				this.energizeList()
			}
		})
	}
	topicChange = (checked, obj, type) => {
		if(obj.status === 0){
			message.error('请先打开发布状态')
			this.subjectList()
			return false
		}
		Modal.confirm({
			title: `${checked ? '同步' : '取消同步'}`,
			content: `${checked ? '确定要同步么？' : '确定要取消同步么？'}`,
			okText: '确定',
			cancelText: '取消',
			onOk: () => {
				this.checkedOk(checked, obj.id, type)
			},
				onCancel: () => {
					this.subjectList()
				}
		})
		// console.log(statu)
	}
	tabClick(e) {
		this.setState({
			type: e,
			searchData: {
				pageNum: 1,
				pageSize: 10,
				status: ''
			},
			vocateSearch: {
				pageNum: 1,
				pageSize: 10
			},
			energizeSearch: {
				pageNum: 1,
				pageSize: 10
			}
		},() => {
			if(this.state.type === 1){
				this.subjectList()
			}else if(this.state.type === 3){
				this.vocatonList()
			}else{
				this.energizeList()
			}
		})
	}
	checkedOk(checked, id, type) {
		axios.post('/subjectController/sync',{id: id,syncStatus: checked?1:0,syncType: type}).then(res => {
			// console.log(res)
			if(res.data.code === '200') {
				message.success(`${checked === true ? '同步成功' : `取消${type===1?'题库':type === 2?'资料包':type === 4?'资料广场':type === 5?'课程管理':'资源管理'}同步成功`}`)
				this.subjectList()
				Modal.destroyAll();
			}else {
				message.error(res.data.msg)
			}
		})
	}
	isRelease = (id,checked,type) => {
		if(type === 'cancel'){
			this.subjectList()
		}else {
			let url = checked?`subjectController/publish/${id}`:`subjectController/cancelPublish/${id}`
			axios.get(url).then(res => {
				if(res.data.code === '200') {
					message.success(`${checked === true ? '发布成功' : '取消发布成功'}`)
					this.subjectList()
					Modal.destroyAll();
				}else {
					// message.error(res.data.msg)
					this.subjectList()
				}
			})
		}
		
	}
	getZsCourseList() {
		axios.get('subjectController/subjects/2').then( res => {
			if(res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					optionList: arr
				})
			}
		})
	}
	getlassifyList() {
		axios.post('dictionaryController/getDictionarysByPid', {pid: 94}).then( res => {
			if(res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					classifyList: arr
				})
			}
		})
	}
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values)
		});
	}
	async subjectList() {
		axios.post('subjectController/getSubject', {
			...this.state.searchData,
			name: this.state.name,
			subjectId: this.state.subject,
			status: this.state.selectValue
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					total: res.data.data.total,
					subjecListData: res.data.data.list,
					notChanged: res.data.data.list,
					searchData: {
						pageNum: res.data.data.pageNum,
						pageSize: res.data.data.pageSize,
						// total: res.data.data.total
					}
				})
			}
		})
	}
	// 删除
	delSubject(type, id) {
		let url = type === 'subjects'?`subjectController/delSubject/${id}`:type === 'vocat'?`employmentcourse/delete/${id}`:`empowerCourseController/delete/${id}`
		// `subjectController/delSubject/${id}`
		axios.get(url).then(res => {
			if(res.data.code === '200') {
				message.success('删除学科成功')
				// this.subjectList()
				this.tabClick(this.state.type)
			}else {
				message.error(res.data.msg)
			}
		})
	}
	delVocation() {
		axios.get(``).then(res => {
			if(res.data.code !== '200'){
				message.success('删除成功')
				this.vocatonList()
			}else{
				message.error(res.data.msg)
			}
		})
	}
	// 就业课列表
	vocatonList() {
		axios.post('employmentcourse/list', {
			...this.state.vocateSearch,
			name: this.state.name,
			subjectId: this.state.subject,
			publish: this.state.selectValue
		}).then(res => {
			console.log(res)
			if(res.data.code !== '200') return message.error(res.data.msg)
			this.setState({vocateData: res.data.data.list, vocatotal: res.data.data.total, vocateSearch: {pageNum: res.data.data.pageNum, pageSize: res.data.data.pageSize}})
		})
	}
	// 赋能课列表
	energizeList() {
		axios.post('empowerCourseController/list', {
			...this.state.energizeSearch,
			name: this.state.name,
			courseType: this.state.courseType,
			publish: this.state.selectValue
		}).then(res => {
			console.log(res)
			if(res.data.code !== '200') return message.error(res.data.msg)
			this.setState({energizeData: res.data.data.list, energtotal: res.data.data.total, energizeSearch: {pageNum: res.data.data.pageNum, pageSize: res.data.data.pageSize}})
		})
	}
	handleOk = (e) => {
		let _this = this
		this.props.form.validateFields((err, values) => {
			// console.log(values)
			if(!err) {
				if(this.state.modelTitle === '新增学科'){
					axios.post('subjectController/addSubject', {
						pic: this.state.qiuniuUrl+'/'+values.uploadUrl.response.key,
						name: values.name,
						uploadType: values.uploadUrl.type,
						uploadUid: values.uploadUrl.uid,
						advPic: this.state.qiuniuUrl+'/'+values.advPic.response.key,
						clickUrl: values.clickUrl,
						groupUrl: values.groupUrl,
						zsCourseId: values.zsCourseId
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.subjectList()
						} else {
							message.error(res.data.msg)
						}
					})
				}else {
					let pic = values.uploadUrl.url&&values.uploadUrl.url ? values.uploadUrl.url :this.state.qiuniuUrl +'/'+ values.uploadUrl.response.key
					let advPic = values.advPic.url&&values.advPic.url ? values.advPic.url :this.state.qiuniuUrl +'/'+ values.advPic.response.key
					axios.post('subjectController/updateSubject', {
						id: _this.state.subjectId,
						pic: pic,
						name: values.name,
						uploadType: values.uploadUrl.type,
						uploadUid: values.uploadUrl.uid,
						advPic: advPic,
						clickUrl: values.clickUrl,
						groupUrl: values.groupUrl,
						zsCourseId: values.zsCourseId
					}).then(res => {
						if (res.data.code === '200') {
							message.success('编辑成功')
							_this.props.form.resetFields();
							_this.setState({ visible: false })
							_this.subjectList()
						} else {
							message.error(res.data.msg)
						}
					})
				}
				
			}
			
		});
	}
	componentDidMount() {
		console.log(localStorage.getItem('type'))
		if(localStorage.getItem('type')) {
			this.setState({type: localStorage.getItem('type') === 'vocat'?3:localStorage.getItem('type') === 'energiz'?4:1},() => {
				if(this.state.type === 3){
					this.vocatonList()
				}else if(this.state.type === 4){
					this.energizeList()
				}
				localStorage.removeItem('type')
			})
		}else{
			this.subjectList()
		}
		this.getZsCourseList()
		this.getlassifyList()
	}
	componentWillUnmount() {
		this.setState = ()=>false;
	}
	showModal() {
		this.setState({ visible: true, modelTitle: '新增学科', subjectIcon: '', advPic: '' })
		this.props.history.push('/createSubject',{courseTitle: '新建'})
	}
	getQiniuUrl  = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	getQiniuUrl2  = v => {
		this.setState({
			qiuniuUrl2: v
		})
	}
	components = {
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => {
		const { subjecListData } = this.state;
		const dragRow = subjecListData[dragIndex];
		this.setState(
			update(this.state, {
				subjecListData: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.subjecListData[i].id })
		}
		axios.post('/subjectController/updateSubjectSort',oldSort).then(res => {
			// console.log(res)
			if(res.data.code === '200' )
			oldSort = []
		})
		

	};
	render() {
		const { columns, subjecListData,  total, type, vocateData, vocateColumn, energizeData, energizeColumn } = this.state;
		const pagination ={
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.subjectList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.subjectList(searchData)
			},
		}
		const vocatPage ={
			showSizeChanger: true,
			total: this.state.vocatotal,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${this.state.vocatotal} 条`,
			onShowSizeChange: (current,pageSize) => {
				let vocateSearch = this.state.vocateSearch
				vocateSearch.pageNum = current
				vocateSearch.pageSize = pageSize
				this.vocatonList(vocateSearch)
			},
			onChange: (current) => {
				let vocateSearch = this.state.vocateSearch
				vocateSearch.pageNum = current
				this.vocatonList(vocateSearch)
			},
		}
		const energizePage = {
			showSizeChanger: true,
			total: this.state.energtotal,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共${this.state.energtotal}条`,
			onShowSizeChange: (current,pageSize) => {
				let energizeSearch = this.state.energizeSearch
				energizeSearch.pageSize = pageSize
				energizeSearch.pageNum = current
				this.energizeList(energizeSearch)
			},
			onChange: (current) => {
				let energizeSearch = this.state.energizeSearch
				energizeSearch.pageNum = current
				this.energizeList(energizeSearch)
			},
		}
		return (
			<div className="openclass">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>视频课程管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div style={{ display: 'flex',alignItems: 'center'}}>
						<span>{type !== 1?'课程':'学科'}名称：</span><Input allowClear value={this.state.name} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入学科名称"
						onChange={(e)=>{
							this.setState({
									name: e.target.value
							})
						}}
						></Input>
						{type === 3?<span>学科：</span>:''}
						{type === 3?<Select placeholder="学科" value={this.state.subject} allowClear style={{ width: 140,  marginRight: '20px' }} onChange={(value) => {
								this.setState({
									subject: value
								})
								}}>
									<Option value={""}>全部</Option>
									{this.state.optionList.map(item => {
										return (<Option key={item.subjectId + item.subjectName} value={item.subjectId}>{item.subjectName}</Option>)
									})}
							</Select>:''}
							{type === 4?<span>课程类型：</span>:''}
							{type === 4?<Select placeholder="课程类型" value={this.state.courseType} allowClear style={{ width: 140,  marginRight: '20px' }} onChange={(value) => {
								this.setState({
									courseType: value
								})
								}}>
									<Option value={""}>全部</Option>
									{this.state.classifyList.map(item => {
										return (<Option key={item.id + item.des} value={item.id}>{item.des}</Option>)
									})}
							</Select>:''}
						<span>发布状态：</span><Select  placeholder="发布状态" value={this.state.selectValue} allowClear style={{ width: 140, height: '40px', marginRight: '20px' }} onChange={(value)=>{
							this.setState({
								selectValue: value
							})
						}}>
							<Option value="0">未发布</Option>
							<Option value="1">已发布</Option>
						</Select>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.tabClick(type)
						}}>搜索</Button>
						<span className="my-button-txt" style={{marginLeft: '20px'}} onClick={() => {
							this.setState({
								selectValue: undefined,
								subject: '',
								courseType: '',
								name: '',
							},()=>{
								this.tabClick(type)
							})
						}}>重置</span>
					</div>
					{type === 1?
					<Button className='my-button-primary' type='primary' onClick={() => { this.showModal() }}>新增学科</Button>
					:type === 3?<Button className='my-button-primary' type='primary' onClick={(() => {this.props.history.push('/createVocation')})}>新建课程</Button>
					:<Button className='my-button-primary' type='primary' onClick={(() => {this.props.history.push('/createEnergize')})}>新建课程</Button>
					}
				</div>

				<div className='tab-button'>
					<Radio.Group onChange={(e) => {this.setState({subject: ''});this.tabClick(e.target.value)}} value={type} buttonStyle="solid">
						<Radio.Button value={1}>免费课</Radio.Button>
						{/* <Radio.Button value={2}>实战课</Radio.Button>
						<Radio.Button value={4}>认证课</Radio.Button> */}
						<Radio.Button value={3}>就业课</Radio.Button>
						<Radio.Button value={4}>赋能课</Radio.Button>
					</Radio.Group>
			</div>
			{type === 1?
				<DndProvider backend={HTML5Backend}>
					<Table
						dataSource={subjecListData}
						columns={columns}
						components={this.components}
						rowKey={record => record.id}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
						pagination={pagination}
					/>
				</DndProvider>
			  :type === 3?
				<DndProvider backend={HTML5Backend}>
				<Table
					dataSource={vocateData}
					columns={vocateColumn}
					components={this.components}
					rowKey={record => record.id}
					rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
					onRow={(record, index) => ({
						index,
						moveRow: this.moveRow,
					})}
					pagination={vocatPage}
				/>
			</DndProvider>
			:
				<Table
					dataSource={energizeData}
					columns={energizeColumn}
					rowKey={record => record.id}
					rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
					pagination={energizePage}
				/>
				}
			</div>
		)
	}
}

export default Form.create()(Openclass)